import { FC } from 'react';
import { Redirect, Route, Switch, useParams } from 'react-router-dom';
import RouteConstants from '@/features/router/RouteConstants';
import { SmsCampaignDetails } from '../Sms/Campaigns/SmsCampaignDetails/SmsCampaignDetails';
import { SmsCampaignList } from '../Sms/Campaigns/SmsCampaignList';
import { SmsSenderEditFlow, SmsSenderInsertFlow, SmsSenderList } from '../Sms/Senders';
import { SmsTemplateList } from '../Sms/Templates/SmsTemplateList';
import { SmsTemplateDeleteWorkaround } from '../Sms/Templates/Workaround/SmsTemplateDeleteWorkaround';
import { SmsTemplateEditWorkaround } from '../Sms/Templates/Workaround/SmsTemplateEditWorkaround';
import { SmsTemplateInsertWorkaround } from '../Sms/Templates/Workaround/SmsTemplateInsertWorkaround';
import { SMS_CREDIT_PACKAGES_CONTENT } from '../Sms/smsCreditPackagesContent';
import { CampaignsCreditPackagesSection } from './CampaignsCreditPackagesSection';
import { CampaignsInnerRoutePlaceholderV2 } from './CampaignsInnerRoutePlaceholderV2';
import { CampaignsSmsCreateFlowV2 } from './CampaignsSmsCreateFlowV2';
import { CampaignsSmsEditFlowV2 } from './CampaignsSmsEditFlowV2';

const SmsTemplateDetailView: FC = () => {
  const { templateId } = useParams<{ templateId: string }>();
  return <CampaignsInnerRoutePlaceholderV2 title='SMS template details' description={`Coming Soon:Details view for template ${templateId}.`} />;
};

const SmsTemplateEditView: FC = () => {
  const { templateId } = useParams<{ templateId: string }>();
  return <CampaignsInnerRoutePlaceholderV2 title='Edit SMS template' description={`Edit flow for template ${templateId}.`} />;
};

const SmsPackagesView: FC = () => <CampaignsCreditPackagesSection content={SMS_CREDIT_PACKAGES_CONTENT} />;

const SmsSenderDetailView: FC = () => {
  const { senderId } = useParams<{ senderId: string }>();
  return <CampaignsInnerRoutePlaceholderV2 title='SMS sender details' description={`Details view for sender ${senderId}.`} />;
};

export const CampaignsSmsRoutesV2: FC = () => (
  <div className='grid w-full grid-cols-1'>
    <Switch>
      <Route exact path={RouteConstants.smsCampaigns} component={SmsCampaignList} />
      <Route exact path={RouteConstants.createCampaignSms} component={CampaignsSmsCreateFlowV2} />
      <Route exact path={RouteConstants.editCampaignSms} component={CampaignsSmsEditFlowV2} />
      <Route exact path={RouteConstants.smsCampaignDetails} component={SmsCampaignDetails} />

      <Route exact path={RouteConstants.smsTemplates} component={SmsTemplateList} />
      <Route exact path={RouteConstants.createSmsTemplate} component={SmsTemplateInsertWorkaround} />
      <Route exact path={RouteConstants.smsTemplatesEditHub} component={SmsTemplateEditWorkaround} />
      <Route exact path={RouteConstants.smsTemplatesDeleteHub} component={SmsTemplateDeleteWorkaround} />
      <Route exact path={RouteConstants.editSmsTemplate} component={SmsTemplateEditView} />
      <Route exact path={RouteConstants.smsTemplateDetails} component={SmsTemplateDetailView} />

      <Route exact path={RouteConstants.smsSenders} component={SmsSenderList} />
      <Route exact path={RouteConstants.createSmsSender} component={SmsSenderInsertFlow} />
      <Route exact path={RouteConstants.editSmsSender} component={SmsSenderEditFlow} />
      <Route exact path={RouteConstants.smsSenderDetails} component={SmsSenderDetailView} />

      <Route exact path={RouteConstants.smsPackages} component={SmsPackagesView} />

      <Route exact path={`${RouteConstants.campaigns}/sms`}>
        <Redirect to={RouteConstants.smsCampaigns} />
      </Route>
    </Switch>
  </div>
);
